import { SNK } from '@/helpers/helpers'
import * as R from 'remeda'
import { setActiveHistorySpot, getEventsTreePreviewApi } from '@/store/gamestate/gamestate'

const getInitialState = ({ namespace }) => {
  const res = {
    rpfrm_namespace: namespace,
  }
  return res
}

const getters = {}

const actions = {
  async rpfrm_getTreePreview(
    { state, dispatch, getters },
    { customTreeId, enable_hsWatcher } = {},
  ) {
    const data = {
      preflop_actions: getters.router_query.preflop_actions,
      flop_actions: getters.router_query.flop_actions,
      custom_tree_id: customTreeId,
    }

    await dispatch(
      'api_poker_tree_preview',
      {
        data,
        action: SNK('rpfrm_handleTreePreview', state.rpfrm_namespace),
        namespace: state.rpfrm_namespace,
        actionArgs: { enable_hsWatcher },
        message: { type: 'error' },
      },
      { root: true },
    )
  },
  rpfrm_handleTreePreview({ state, dispatch, getters, rootGetters }, result) {
    if (rootGetters.poker_diss_history_calls(state.rpfrm_namespace)) return

    if (result?.response?.status !== 200 || !result.response?.data) {
      return
    }

    const data = result.response?.data

    let l_hSpots = getters.history_spots

    let { history_spots: hSpots } = getEventsTreePreviewApi({
      future_spots: [],
      history_spots: data.history_actions,
    })

    const lastSpotWithSelectedAction = R.findLast(hSpots, i => i.selected_action_code)
    const l = hSpots.length - 1
    let hSpotId = !lastSpotWithSelectedAction
      ? 0
      : lastSpotWithSelectedAction
        ? lastSpotWithSelectedAction.id + 1
        : l

    hSpotId = hSpotId > l ? l : hSpotId

    // cusso reports end on flop and then we show gg
    let calledForGG = false
    if (hSpots[hSpotId].street === 'turn') {
      hSpotId--
      calledForGG = true
    }

    hSpots = setActiveHistorySpot({
      history_spots: hSpots,
      spot_id: hSpotId,
    })

    // keep all previous spots and replace only the active one
    // cos there might be added frequencies on them from generated reports
    l_hSpots = getters.history_spots
    hSpots = hSpots.map(hs => {
      const local_hSpot = l_hSpots.find(i => i.id === hs.id)
      if (local_hSpot && (calledForGG || !hs.is_active)) {
        return local_hSpot
      }

      if (!hs.available_actions[0]?.frequency) {
        // There're no cussol reports on preflop so we have set the frequency to some positive number
        // on another streets we just have to make sure actions have 'frequency' property
        const frequency = hs.street === 'preflop' ? 420 : 0
        return {
          ...hs,
          available_actions: hs.available_actions.map(a => ({
            ...a,
            frequency: a.frequency || frequency,
          })),
        }
      }
      return hs
    })
    const history_spot = hSpots[hSpotId]
    if (history_spot?.type === 'showdown') {
      hSpotId -= 1
    }

    if (result.enable_hsWatcher) {
      dispatch('globals_action', 'disable_history_watcher', { root: true })
    }
    setTimeout(() => {
      dispatch('gamestate_set_history', {
        history_spots: hSpots,
        spot_id: hSpotId,
        push: false,
        saveLocally: true,
      })
      if (result.enable_hsWatcher) {
        setTimeout(() => {
          dispatch('globals_action', 'enable_history_watcher', { root: true })
        })
      }
    })
  },
  rpfrm_emptyFrequenciesOnCurrentSpot({ getters, dispatch }) {
    // When you already have report generated and you switch to Strategy and back the time till /tree-preview
    // is fetched and existence of report is checked actions on current spot are enabled
    const hSpots = getters.history_spots.map(hs => {
      if (hs.is_active) {
        hs.available_actions = hs.available_actions.map(a => ({
          ...a,
          frequency: 0,
        }))
      }
      return hs
    })
    dispatch('gamestate_set', {
      key: 'history_spots',
      value: hSpots,
    })
  },
}

const mutations = {}

function getRepfigrModule(namespace) {
  return {
    state: getInitialState({ namespace }),
    getters,
    actions,
    mutations,
  }
}

export { getRepfigrModule }
